module.exports = __webpack_public_path__ + "img/sprite.6a7881bc.svg";